const getFileExtension = (fileName: string) => {
  if (!fileName || typeof fileName !== "string") return null;

  const fileSplit = fileName.split(".");
  if (!fileSplit.length) return null;
  return fileSplit[fileSplit.length - 1]?.toLowerCase();
};

export default getFileExtension;
